module.exports = __webpack_public_path__ + "img/instagram-icon.730f87b6.svg";